var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.842,
    height: 21,
    viewBox: "0 0 29.842 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16265",
    "data-name": "Group 16265",
    transform: "translate(-5 -7)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18978",
    "data-name": "Path 18978",
    d: "M44.053,11H31.316a1.739,1.739,0,0,0-1.737,1.737V23.158a1.739,1.739,0,0,0,1.737,1.737H44.053a1.739,1.739,0,0,0,1.737-1.737V12.737A1.739,1.739,0,0,0,44.053,11ZM34.789,22a.579.579,0,0,1-.579.579H31.895A.579.579,0,0,1,31.316,22V20.842a1.737,1.737,0,0,1,3.474,0Zm4.632,0a.579.579,0,0,1-.579.579H36.526A.579.579,0,0,1,35.947,22V17.368a1.737,1.737,0,0,1,3.474,0Zm4.632,0a.579.579,0,0,1-.579.579H41.158A.579.579,0,0,1,40.579,22V15.053a1.737,1.737,0,1,1,3.474,0Z",
    transform: "translate(-10.947 -1.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18979",
    "data-name": "Path 18979",
    d: "M5,41.472v.107a1.739,1.739,0,0,0,1.737,1.737H31.211a1.739,1.739,0,0,0,1.737-1.737v-.107Z",
    transform: "translate(0.078 -15.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18980",
    "data-name": "Path 18980",
    d: "M20.34,24.368a2.9,2.9,0,0,1-2.895-2.895V11.053A2.9,2.9,0,0,1,20.34,8.158h12.5A1.735,1.735,0,0,0,31.211,7H6.737A1.739,1.739,0,0,0,5,8.737V25.526H32.947V24.368ZM11.366,23.2a4.63,4.63,0,0,1-.579-9.223v4.591a.579.579,0,0,0,.579.579h4.591A4.636,4.636,0,0,1,11.366,23.2Zm-4.632-11a.579.579,0,0,1,.579-.579h4.053a.579.579,0,0,1,0,1.158H7.313A.579.579,0,0,1,6.735,12.2Zm5.211,5.789V13.979a4.635,4.635,0,0,1,4.012,4.012Zm3.632-7.526H7.313a.579.579,0,1,1,0-1.158h8.263a.579.579,0,0,1,0,1.158Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.96e572cdc92516afa0a17426076fb944.svg";
export { ForwardRef as ReactComponent };